module.exports = __webpack_public_path__ + "static/assets/ca371f9572af75cec600b82eb1da0d1c.png";